import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ProductExportModels } from '../models/product_export_model'; 

@Injectable({
  providedIn: 'root'
})
export class ProductExportService {

  constructor(private http: HttpClient) { }

  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return headers;
  }

  myHeaders = this.setHeader();

  getAllProductExport(value, column, pageId) {
    let url =
      environment.URL +
      "/productExport/" +
      value +
      "/" +
      column +
      "/" +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  exportFieldRecordById(export_id) {
    let url = environment.URL + "/productExport/edit/" + export_id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  addProductExport(bodyParams: any) {
    console.log(bodyParams)
    let url = environment.URL + "/productExport/createProductExport";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateProductExport(bodyParams: any) {
    let url = environment.URL + "/productExport/productExportUpdate";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  deleteProductExport(export_id) {
    let url = environment.URL + "/productExport/delete/" + export_id;
    return this.http.get(url, { headers: this.myHeaders });
  }
}
